"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcCollectionCosts = void 0;
const common_1 = require("./common");
const selfCollectionCosts = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => (0, common_1.money)(350),
        },
        {
            from: 1001,
            to: 2500,
            value: () => (0, common_1.money)(600),
        },
        {
            from: 2501,
            to: 5000,
            value: () => (0, common_1.money)(800),
        },
        {
            from: 5001,
            to: 10000,
            value: () => (0, common_1.money)(1000),
        },
        {
            from: 10001,
            to: 25000,
            value: () => (0, common_1.money)(1400),
        },
        {
            from: 25001,
            to: 50000,
            value: () => (0, common_1.money)(1700),
        },
        {
            from: 50001,
            to: 100000,
            value: () => (0, common_1.money)(2250),
        },
        {
            from: 100001,
            to: 250000,
            value: () => (0, common_1.money)(3050),
        },
        {
            from: 250001,
            to: 500000,
            value: () => (0, common_1.money)(5100),
        },
        {
            from: 500001,
            value: (n) => Math.round((0, common_1.money)(5100) + Math.max(0, n - (0, common_1.money)(500000)) * 0.0067),
        },
    ],
};
const foreignCollectionCosts = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => (0, common_1.money)(500),
        },
        {
            from: 1001,
            to: 2500,
            value: () => (0, common_1.money)(850),
        },
        {
            from: 2501,
            to: 5000,
            value: () => (0, common_1.money)(1200),
        },
        {
            from: 5001,
            to: 10000,
            value: () => (0, common_1.money)(1550),
        },
        {
            from: 10001,
            to: 25000,
            value: () => (0, common_1.money)(2050),
        },
        {
            from: 25001,
            to: 50000,
            value: () => (0, common_1.money)(2700),
        },
        {
            from: 50001,
            to: 100000,
            value: () => (0, common_1.money)(3450),
        },
        {
            from: 100001,
            to: 250000,
            value: () => (0, common_1.money)(3650),
        },
        {
            from: 250001,
            to: 500000,
            value: () => (0, common_1.money)(7700),
        },
        {
            from: 500001,
            value: (n) => Math.round((0, common_1.money)(7700) + Math.max(0, n - (0, common_1.money)(500000)) * 0.01),
        },
    ],
};
exports.calcCollectionCosts = (0, common_1.calcCollectionCostGen)(selfCollectionCosts, foreignCollectionCosts);
//# sourceMappingURL=denmark.js.map